/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskIndicator } from './RiskIndicator';
import { RiskIndicatorFromJSON, RiskIndicatorFromJSONTyped, RiskIndicatorToJSON } from './RiskIndicator';

/**
 *
 * @export
 * @interface PaginatedRiskIndicatorList
 */
export interface PaginatedRiskIndicatorList {
  /**
   *
   * @type {number}
   * @memberof PaginatedRiskIndicatorList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedRiskIndicatorList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedRiskIndicatorList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<RiskIndicator>}
   * @memberof PaginatedRiskIndicatorList
   */
  results: Array<RiskIndicator>;
}

/**
 * Check if a given object implements the PaginatedRiskIndicatorList interface.
 */
export function instanceOfPaginatedRiskIndicatorList(value: object): value is PaginatedRiskIndicatorList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedRiskIndicatorListFromJSON(json: any): PaginatedRiskIndicatorList {
  return PaginatedRiskIndicatorListFromJSONTyped(json, false);
}

export function PaginatedRiskIndicatorListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedRiskIndicatorList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(RiskIndicatorFromJSON),
  };
}

export function PaginatedRiskIndicatorListToJSON(value?: PaginatedRiskIndicatorList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(RiskIndicatorToJSON),
  };
}
